import * as Yup from 'yup';
import { SarlaftSendEmail } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftSendEmail = {
    sendEmail: false,
};

export const validationSchema = Yup.object({
    sendEmail: Yup.boolean(),
});
